export const Solidworks = "ADAPT_SW";
export const Creo = "ADAPT_CRE";
export const NX = "ADAPT_NX";
export const Catia = "ADAPT_CAT";
export const Inventor = "ADAPT_INV";
export const SDK = "ADAPT_SDK";
export type CadSystems = typeof NX | typeof Catia | typeof Inventor | typeof Creo | typeof Solidworks | typeof SDK;

export type LicenseType = 'EVAL' | 'NEW' | 'ANARK';

export const WorkstationEnterpriseEdition = 'WS_EN';
export const WorkstationProfessionalEdition = 'WS_PR';
export const PublishEdition = 'PUB';


export interface IAddon {
	id: number;
	addon: CadSystems;
}

export interface ILicense {
	code: string;
	revoked: boolean;
	edition: typeof WorkstationEnterpriseEdition | typeof WorkstationProfessionalEdition | typeof PublishEdition;
	expiry: string;
	created: Date;
	licenseType: LicenseType;
	author: string;
	addons: CadSystems[] | IAddon[];
	invoice: string;
	history: string[];
	used: number;
	allowed: number;
	floating: boolean;
	notes: string;
	customer: string;
}

export interface ICustomer {
	id: number;
	name: string;
	company: ICompany;
	email: string;
	phone: string;
	address: string;
	licenses: ILicense[];
}

export interface ICompany {
	id: number;
	name: string;
}

export enum ApplicationMode {
	Unknown = 0,
    CoreServer = 1,
    CoreWorkstation = 2,
    FloatingLicenseServer = 3
}

export interface IActivationRequest {
	activationCode: string;
	diskSerialNumber: string | null;
    hostName: string;
    macAddress: string | null;
    internalIp: string;
    vmType: 0 | 1 | 2 | null;
    dongle: string | null;
    applicationMode: ApplicationMode | null;
}
